var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "decorationManage" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "80%",
            "destroy-on-close": "",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", { staticClass: "el-icon-s-tools" }),
              _vm._v(" "),
              _c("span", [_vm._v("装修管理")]),
              _vm._v(" "),
              _vm.appCustomerName
                ? _c("span", { staticClass: "customer-tag" }, [
                    _vm._v("归属客户：" + _vm._s(_vm.appCustomerName)),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "table-toolbar" }, [
            _c(
              "div",
              { staticClass: "toolbar-left" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: ["admin:company-design:saveOrUpdate"],
                        expression: "['admin:company-design:saveOrUpdate']",
                      },
                    ],
                    attrs: { type: "primary", icon: "el-icon-plus" },
                    on: { click: _vm.add },
                  },
                  [_vm._v("添加专题页")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: ["admin:company-design:saveOrUpdate"],
                        expression: "['admin:company-design:saveOrUpdate']",
                      },
                    ],
                    attrs: { type: "success", icon: "el-icon-user" },
                    on: { click: _vm.addVisitor },
                  },
                  [_vm._v("添加游客首页")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "toolbar-right" }, [
              _c("span", { staticClass: "total-count" }, [
                _vm._v("共 " + _vm._s(_vm.tableData.total) + " 条记录"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData.list,
                stripe: "",
                border: "",
                "header-cell-style": {
                  background: "#f5f7fa",
                  color: "#606266",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "页面名称",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "归属客户",
                  "min-width": "140",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "title",
                  label: "页面标题",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "url", label: "链接", "min-width": "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "url-text" }, [
                          _vm._v(
                            _vm._s(
                              scope.row.type === 1 || scope.row.type === 5
                                ? "/pages/index/index"
                                : "/pages/activity/skin_activity/index?skinId=" +
                                    scope.row.id
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "typeName", label: "页面类型", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 1
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "primary",
                                  effect: "dark",
                                  size: "small",
                                },
                              },
                              [_vm._v("首页（使用中）")]
                            )
                          : scope.row.type === 5
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "success",
                                  effect: "dark",
                                  size: "small",
                                },
                              },
                              [_vm._v("游客首页（使用中）")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v(_vm._s(scope.row.typeName))]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "statusName", label: "页面状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 1
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "success",
                                  effect: "plain",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.statusName))]
                            )
                          : scope.row.status === 2
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "warning",
                                  effect: "plain",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.statusName))]
                            )
                          : _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "info",
                                  effect: "plain",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.statusName))]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "200", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            scope.row.type === 2
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:company-design:decoration",
                                        ],
                                        expression:
                                          "['admin:company-design:decoration']",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.go(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("去装修")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status === 1 && scope.row.type === 2
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:company-design:setHomepage",
                                        ],
                                        expression:
                                          "['admin:company-design:setHomepage']",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setHomePage(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("设为首页")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status === 1 && scope.row.type === 2
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:company-design:setVisitorHomepage",
                                        ],
                                        expression:
                                          "['admin:company-design:setVisitorHomepage']",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setVisitorHomePage(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("设为游客首页")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "page-sizes": [20, 40, 60, 80],
              "page-size": _vm.pageData.limit,
              "current-page": _vm.pageData.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }